import { Capacitor } from '@capacitor/core';

export function isNativePlatform() {
  return Capacitor.isNativePlatform();
}

export function getApiBaseUrl() {
  if (isNativePlatform()) {
    return 'https://finance-forecaster-api-fuf7fghdc0gbgggu.westus2-01.azurewebsites.net';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5002';
}
